export default "__VITE_ASSET__e188d1dc__"